import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

const EngineeringRequirementsNotice = ({ requirements }) => {
  // If no requirements data, don't render anything
  if (!requirements || (!requirements.MechanicalEngineering && !requirements.ElectricalEngineering && !requirements.ProgrammingRequired)) {
    return null;
  }

  return (
    <Alert variant="info" className="mb-3 d-flex">
      <div>
        <div className="fw-bold mb-2">Engineering Requirements from Manufacturing Order:</div>
        <ul className="mb-0">
          {requirements.MechanicalEngineering && (
            <li><strong>Mechanical Engineering:</strong> {requirements.MechanicalEngineering}</li>
          )}
          {requirements.ElectricalEngineering && (
            <li><strong>Electrical Engineering:</strong> {requirements.ElectricalEngineering}</li>
          )}
          {requirements.ProgrammingRequired && (
            <li><strong>Programming Required:</strong> {requirements.ProgrammingRequired}</li>
          )}
        </ul>
      </div>
    </Alert>
  );
};

EngineeringRequirementsNotice.propTypes = {
  requirements: PropTypes.shape({
    MechanicalEngineering: PropTypes.string,
    ElectricalEngineering: PropTypes.string,
    ProgrammingRequired: PropTypes.string
  })
};

export default EngineeringRequirementsNotice;
